import { render, staticRenderFns } from "./MarketTermsView.vue?vue&type=template&id=2dda5f3b"
import script from "./MarketTermsView.vue?vue&type=script&lang=js"
export * from "./MarketTermsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports